import { getQueryParam } from './getQueryParam'

export enum LogLevel {
  silent = 'silent',
  debug = 'debug'
}

export const DEFAULT_LOG_LEVEL = LogLevel.silent

export class Logger {
  constructor(readonly logLevel: LogLevel) {}

  debug = (...args): Logger => this.custom('debug', ...args)

  custom(levels: string | Array<any>, ...messages): Logger {
    if (this.isCurrentLogLevel(levels)) {
      window.console.log(...messages)
    }

    return this
  }

  private isCurrentLogLevel(levels: string | Array<string>): boolean {
    return (
      this.logLevel === levels ||
      (Array.isArray(levels) && levels.includes(this.logLevel))
    )
  }
}

export default new Logger(
  (getQueryParam('loglevel', window.location.search) as LogLevel) ||
    DEFAULT_LOG_LEVEL
)
